var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68653 1 1 3.68628 1 7C1 10.3137 3.68653 13 7 13C8.12159 13 9.16994 12.6926 10.0674 12.1578C10.0982 12.1395 10.1304 12.1249 10.1636 12.1137C10.1894 12.1048 10.2163 12.0983 10.2432 12.0939C10.2793 12.0879 10.3164 12.0859 10.353 12.0881C10.3936 12.0906 10.4336 12.0979 10.4732 12.1103L12.8608 12.8607L12.1103 10.4733C12.0679 10.3374 12.085 10.1897 12.1577 10.0674C12.6929 9.17016 13 8.12172 13 7C13 3.68628 10.3135 1 7 1ZM0 7C0 3.13403 3.13378 0 7 0C10.8662 0 14 3.13403 14 7C14 8.22584 13.6846 9.37941 13.1299 10.3823L13.9585 13.0179C14.1401 13.5963 13.5962 14.1401 13.0181 13.9584L10.3823 13.13C9.37941 13.6844 8.22606 14 7 14C3.13378 14 0 10.866 0 7ZM7.5 6.25V10C7.5 10.1292 7.45119 10.2469 7.37059 10.3357C7.30078 10.4131 7.20653 10.4684 7.10009 10.49C7.06788 10.4966 7.03419 10.5 7 10.5C6.85497 10.5 6.72463 10.4385 6.63331 10.3402C6.55078 10.251 6.5 10.1313 6.5 10V6.25C6.5 5.97387 6.72363 5.75 7 5.75C7.27637 5.75 7.5 5.97387 7.5 6.25ZM7 5C7.41406 5 7.75 4.66419 7.75 4.25C7.75 3.95888 7.584 3.70641 7.34181 3.58216C7.23925 3.52966 7.12306 3.5 7 3.5C6.58594 3.5 6.25 3.83581 6.25 4.25C6.25 4.66419 6.58594 5 7 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.1d6551365f1f6cf0698ceb3498ab0fc0.svg";
export { ForwardRef as ReactComponent };